import { Box, BoxProps, FileSelector, ModalDialog, Spacer, TextNew, TextNewProps } from '@jfs/ui-new'

import { useCallback, useEffect, useState } from 'react'

import { FileSelectorInnerComp } from '../../../../../components/FileSelectorInnerComp'
import { useLazyApiData, useStores } from '../../../../../data/store'

interface UploadFileModalProps {
  show: boolean
  onDismiss: () => {}
  title: string
  uploadFileReqMapper: any
  uploadFileReqConstants: any
  uploadId: any
  documentTypeData: any
  docCategoryLov: any
}

export const UploadFileModal = ({
  show,
  onDismiss,
  title,
  uploadFileReqMapper,
  uploadFileReqConstants,
  uploadId,
  docCategoryLov,
  documentTypeData,
  ...props
}: UploadFileModalProps) => {
  console.log('formProps = ', props)

  const { kycUploadFile, setMessage } = useStores((store) => ({
    kycUploadFile: store.kycUploadFile,
    setMessage: store.message.setMessage,
  }))
  const [percent, setPercent] = useState(0)
  const [file, setFile] = useState(null)

  const [uploadKyc, uploadKycHandler] = useLazyApiData(kycUploadFile)
  const onFileSelected = useCallback(
    (file: File) => {
      if (file) {
        setFile(file)
        setPercent(30)
        uploadKyc(
          file,
          uploadFileReqConstants.documentCategory ??
            docCategoryLov.find(
              (item) => item.description === (props as any)?.allValues?.[uploadFileReqMapper.documentCategory],
            )?.value??"",
          (uploadFileReqConstants.documentNumber ?? (props as any)?.allValues?.[uploadFileReqMapper.documentNumber])??"",
          (uploadFileReqConstants.documentName ?? (props as any)?.allValues?.[uploadFileReqMapper.documentName])??"",
          uploadFileReqConstants.dateOfExpiry ?? (props as any)?.allValues?.[uploadFileReqMapper.dateOfExpiry] ?? '',
          uploadFileReqConstants.uploadType ?? (props as any)?.allValues?.[uploadFileReqMapper.uploadType]??"",
          uploadId,
          '',
          uploadFileReqConstants.documentType ??
            documentTypeData.find(
              (item) => item.value === (props as any)?.allValues?.[uploadFileReqMapper.documentType],
            )?.key ??"",
        )
      }
    },
    [
      props,
      uploadFileReqConstants.dateOfExpiry,
      uploadFileReqConstants.documentCategory,
      uploadFileReqConstants.documentName,
      uploadFileReqConstants.documentNumber,
      uploadFileReqConstants.uploadType,
      uploadFileReqMapper.dateOfExpiry,
      uploadFileReqMapper.documentCategory,
      uploadFileReqMapper.documentName,
      uploadFileReqMapper.documentNumber,
      uploadFileReqMapper.uploadType,
      uploadId,
      uploadKyc,
    ],
  )

  useEffect(() => {
    console.log('uploadKycHandler.state=', uploadKycHandler.state)
    if (uploadKycHandler.state === 'fulfilled') {
      setPercent(100)
      onDismiss()
    } else if (uploadKycHandler.state === 'rejected') {
      onDismiss()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadKycHandler.state])

  return (
    <ModalDialog type="CenteredWrap" show={show} onDismiss={onDismiss}>
      <Box {...styles.container}>
        <TextNew title={title} {...styles.titleText} />
        <Spacer size={32} direction={'vertical'} />
        <Box {...styles.fileSelectorContainer}>
          <FileSelector
            innerCompTitle={'Drop your file here or'}
            innnerCompSubtitle={'Click to upload'}
            onFileSelect={onFileSelected}
            fileType={'.pdf,.jpg,.jpeg,.png,.xls,.xlsx,.doc,.docx,.zip' as any}
            fileId={uploadKycHandler?.data?.data?.id}
            filename={file?.name}
            isLoading={uploadKycHandler?.state === 'pending'}
            onCancelPress={() => {}}
            percent={percent}
            showRemoveFile={true}
            InnerComp={FileSelectorInnerComp}
            showToast={setMessage}
            onDismiss={onDismiss}
          />
        </Box>
      </Box>
    </ModalDialog>
  )
}

const styles = {
  container: {
    justify: 'center',
    alignItems: 'center',
    bg: 'WHITE',
    ph: 24,
    pv: 16,
    borderRadius: 4,
  } as BoxProps,
  titleText: {
    fontSize: 16,
    fontFamily: 'jioType-medium',
  } as TextNewProps,
  fileSelectorContainer: {
    minWidth: 500,
  } as BoxProps,
}
